/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertEscalationStatus } from './ControlZeroDayAlertEscalationStatus';
import {
    ControlZeroDayAlertEscalationStatusFromJSON,
    ControlZeroDayAlertEscalationStatusFromJSONTyped,
    ControlZeroDayAlertEscalationStatusToJSON,
} from './ControlZeroDayAlertEscalationStatus';
import type { ControlZeroDayAlertResolutionStatus } from './ControlZeroDayAlertResolutionStatus';
import {
    ControlZeroDayAlertResolutionStatusFromJSON,
    ControlZeroDayAlertResolutionStatusFromJSONTyped,
    ControlZeroDayAlertResolutionStatusToJSON,
} from './ControlZeroDayAlertResolutionStatus';

/**
 * 
 * @export
 * @interface ControlUpdateZeroDayAlertClientRequest
 */
export interface ControlUpdateZeroDayAlertClientRequest {
    /**
     * 
     * @type {ControlZeroDayAlertResolutionStatus}
     * @memberof ControlUpdateZeroDayAlertClientRequest
     */
    resolution_status?: ControlZeroDayAlertResolutionStatus;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ControlUpdateZeroDayAlertClientRequest
     */
    impacted_assets: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ControlZeroDayAlertEscalationStatus}
     * @memberof ControlUpdateZeroDayAlertClientRequest
     */
    escalation_status?: ControlZeroDayAlertEscalationStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertClientRequest
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateZeroDayAlertClientRequest
     */
    assignee?: string;
}

/**
 * Check if a given object implements the ControlUpdateZeroDayAlertClientRequest interface.
 */
export function instanceOfControlUpdateZeroDayAlertClientRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "impacted_assets" in value;

    return isInstance;
}

export function ControlUpdateZeroDayAlertClientRequestFromJSON(json: any): ControlUpdateZeroDayAlertClientRequest {
    return ControlUpdateZeroDayAlertClientRequestFromJSONTyped(json, false);
}

export function ControlUpdateZeroDayAlertClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpdateZeroDayAlertClientRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlZeroDayAlertResolutionStatusFromJSON(json['resolution_status']),
        'impacted_assets': json['impacted_assets'],
        'escalation_status': !exists(json, 'escalation_status') ? undefined : ControlZeroDayAlertEscalationStatusFromJSON(json['escalation_status']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'assignee': !exists(json, 'assignee') ? undefined : json['assignee'],
    };
}

export function ControlUpdateZeroDayAlertClientRequestToJSON(value?: ControlUpdateZeroDayAlertClientRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resolution_status': ControlZeroDayAlertResolutionStatusToJSON(value.resolution_status),
        'impacted_assets': value.impacted_assets,
        'escalation_status': ControlZeroDayAlertEscalationStatusToJSON(value.escalation_status),
        'notes': value.notes,
        'assignee': value.assignee,
    };
}

